import Vue from 'vue';
import { init } from '@sentry/browser';
import { Vue as VueIntergration } from '@sentry/integrations';

const envs = ['production', 'staging'];

// eslint-disable-next-line no-constant-condition
if (envs.includes(process.env.VUE_APP_ENVIRONMENT)) {
  init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntergration({ Vue, attachProps: true })],
    release: process.env.VUE_APP_RELEASE,
    environment: process.env.VUE_APP_ENVIRONMENT,
  });
}
